import React from 'react';
import { Tooltip } from 'react-tooltip';
//utils
import { generateRandomId } from 'utils/GenerateRandomId';

interface TooltipIconProps {
  alt: string;
  icon: string;
  tooltip: string;
  size?: string | number;
}

export const TooltipIcon: React.FC<TooltipIconProps> = (props) => {
  const { tooltip, icon, alt, size } = props;
  const tooltipId = generateRandomId("TooltipIcon");

  const iconStyle = size
    ? { marginRight: "5px",
        width: typeof size === "number" ? `${size}px` : size,
        height: typeof size === "number" ? `${size}px` : size
      }
    : undefined;

  return (
    <>
      <img
        data-tooltip-content={tooltip || undefined}
        data-tooltip-id={tooltipId}
        data-tooltip-place='top'
        alt={alt}
        src={icon}
        className="ml-1"
        style={iconStyle}
      />
      {tooltip && <Tooltip id={tooltipId} variant="light" />}
    </>
  );
};